import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-bazaarvoice-rating',
    templateUrl: './bazaarvoice-rating.component.html',
    styleUrls: ['./bazaarvoice-rating.component.css'],
    standalone: false
})
export class BazaarvoiceRatingComponent implements OnInit {

  @Input() productId: any;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      document.getElementById("bazaarvoice-inline-rating-" + this.productId).setAttribute("data-bv-product-id", this.productId);
      setTimeout(() => {
        document.querySelectorAll('.bv_sub_container .bv_text').forEach(el => {
          const text = el.textContent.trim();
          if (text === '0.0' || text === '(0)') {
            el.textContent = '';
          }
        });
      }, 500)
    })

    const intervalId = setInterval(() => {
      document.querySelectorAll('.bv_main_container').forEach(el => {
        el.removeAttribute('itemscope');
        el.removeAttribute('itemtype');
        el.removeAttribute('itemprop');
      });
    }, 500)

    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  }

}
